var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex flex-column",staticStyle:{"gap":"16px"}}),_c('ListCommercialProjection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }